/* /assets/recommended-product.js */
class RecommendedProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.product = JSON.parse(this.dataset.product);
    // console.log('recommended-product connectedCallback', this.product);
    this.availableVariants = this.product.variants.filter(v => v.available);
    this.currentVariant = this.availableVariants[0] || this.product.variants[0];

    this.render();
    this.addEventListeners();
  }

  render() {
    this.innerHTML = `
      <div class="recommendation-card">
        <a href="${this.product.url}" class="recommendation-card__image-link">
          <img
            src="${this.currentVariant.featured_image || this.product.featured_image}"
            alt="${this.currentVariant.title || this.product.title}"
            loading="lazy"
            width="200"
            height="200"
            data-product-image
          >
        </a>
        <div class="recommendation-card__info">
          <a href="${this.product.url}" class="recommendation-card__title">
            ${this.product.title}
          </a>
          <p class="recommendation-card__price" data-product-price>
            ${new Intl.NumberFormat(Shopify.locale, { style: 'currency', currency: Shopify.currency.active }).format(this.currentVariant.price / 100)}
          </p>
          <form class="recommendation-card__form" data-product-form>
            ${this.renderVariantSelector()}
            <button
              type="submit"
              class="recommendation-card__add-button"
              data-add-to-cart-button
              ${this.currentVariant.available ? '' : 'disabled'}
            >
              ${this.currentVariant.available ? '+' : 'Sold Out'}
            </button>
          </form>
        </div>
      </div>
    `;
  }

  renderVariantSelector() {
    if (this.product.variants.length <= 1) {
      return `<input type="hidden" name="id" value="${this.currentVariant.id}">`;
    }

    return `
      <select name="id" class="recommendation-card__variant-select" data-variant-selector>
        ${this.product.variants.map(variant => `
          <option
            value="${variant.id}"
            ${variant.id === this.currentVariant.id ? 'selected' : ''}
            ${variant.available ? '' : 'disabled'}
          >
            ${variant.title}
          </option>
        `).join('')}
      </select>
    `;
  }

  addEventListeners() {
    const variantSelector = this.querySelector('[data-variant-selector]');
    if (variantSelector) {
      variantSelector.addEventListener('change', this.onVariantChange.bind(this));
    }

    const form = this.querySelector('[data-product-form]');
    if (form) {
      form.addEventListener('submit', this.onFormSubmit.bind(this));
    } else {
      // create pseudo form div element 
      const hiddenInput = this.querySelector('input[name="id"]');
      const variantSelector = this.querySelector('[data-variant-selector]');
      const addToCartButton = this.querySelector('[data-add-to-cart-button]');

      const pseudoFormParent = this.querySelector('.recommendation-card__info');
      if (!pseudoFormParent) return;

      const pseudoForm = document.createElement('div');
      pseudoForm.classList.add('recommendation-card__form');

      if (hiddenInput) pseudoForm.appendChild(hiddenInput);
      if (variantSelector) pseudoForm.appendChild(variantSelector);
      if (addToCartButton) pseudoForm.appendChild(addToCartButton);
      
      pseudoFormParent.appendChild(pseudoForm);


      this.querySelector('[data-add-to-cart-button]').addEventListener('click', this.onFormSubmit.bind(this));
    }
  }

  onVariantChange(event) {
    const selectedVariantId = parseInt(event.target.value, 10);
    this.currentVariant = this.product.variants.find(v => v.id === selectedVariantId);
    this.updateUI();
  }

  updateUI() {
    // Update Price
    const priceElement = this.querySelector('[data-product-price]');
    if (priceElement) {
      if (typeof Shopify !== 'undefined' && Shopify.locale && Shopify.currency) {
        // Use Shopify's formatting if available
        priceElement.textContent = new Intl.NumberFormat(Shopify.locale, { 
          style: 'currency', 
          currency: Shopify.currency.active 
        }).format(this.currentVariant.price / 100);
      } else {
        // Fallback formatting
        priceElement.textContent = (this.currentVariant.price / 100).toFixed(2);
      }
    }

    // Update Image
    const imageElement = this.querySelector('[data-product-image]');
    if (imageElement && (this.currentVariant.featured_image || this.product.featured_image)) {
      imageElement.src = this.currentVariant.featured_image || this.product.featured_image;
      imageElement.alt = this.currentVariant.title || this.product.title;
    }

    // Update hidden input (for single variant products)
    const hiddenInput = this.querySelector('input[name="id"]');
    if (hiddenInput) {
      hiddenInput.value = this.currentVariant.id;
    }

    // Update Button
    const buttonElement = this.querySelector('[data-add-to-cart-button]');
    if (buttonElement) {
      buttonElement.disabled = !this.currentVariant.available;
      buttonElement.textContent = this.currentVariant.available ? '+' : 'Sold Out';
    }
  }

  onFormSubmit(event) {
    event.preventDefault();
    const button = this.querySelector('[data-add-to-cart-button]');
    button.disabled = true;

    // Get source from data attribute or default to 'cart_recommendations'
    const source = this.getAttribute('data-source') || 'cart_recommendations';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: this.currentVariant.id,
        quantity: 1,
        properties: {
          '_source': source
        }
      })
    })
    .then(response => response.json())
    .then(line_item => {
      if (line_item.status) {
        console.error('Error adding to cart:', line_item.description);
        this.updateUI();
        throw new Error(line_item.description); // Stop the promise chain
      }
      return fetch('/cart.js'); // Fetch the full cart state
    })
    .then(response => response.json())
    .then(cart => {
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));

      button.disabled = false;
    })
    .catch(error => {
      console.error('Error:', error);
      this.updateUI(); // Re-enable button on error
    });
  }
}

if (!customElements.get('recommended-product')) {
  customElements.define('recommended-product', RecommendedProduct);
} 